const initialPropertiesState = {
    propertiesData: [],
	isPropertiesLoading: true
};

export default initialPropertiesState;